/**
 * i18n Configuration
 */
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import moment from 'moment';
import 'moment/locale/ar';

// Import translation files
import enTranslations from './locales/en.json';
import arTranslations from './locales/ar.json';

i18n
  // Detect user language
  .use(LanguageDetector)
  // Pass the i18n instance to react-i18next
  .use(initReactI18next)
  // Initialize i18next
  .init({
    resources: {
      en: {
        translation: enTranslations,
      },
      ar: {
        translation: arTranslations,
      },
    },
    fallbackLng: 'en',
    defaultNS: 'translation',
    interpolation: {
      escapeValue: false, // React already escapes values
    },
    detection: {
      // Order of language detection
      order: ['localStorage', 'navigator'],
      // Keys to lookup language from
      lookupLocalStorage: 'i18nextLng',
      // Cache user language
      caches: ['localStorage'],
    },
  });

// Initialize language from localStorage if available
const savedLanguage = localStorage.getItem('i18nextLng') || localStorage.getItem('language');
if (savedLanguage && (savedLanguage === 'en' || savedLanguage === 'ar')) {
  i18n.changeLanguage(savedLanguage);
}

/**
 * Keep moment's global locale in step with the UI language so every
 * `moment(...).format(...)` renders Arabic month names and Arabic-Indic digits
 * when the dashboard is in Arabic. Call sites that need machine-readable output
 * (input values, filenames) opt out with `.locale('en')`.
 */
const syncMomentLocale = (lng?: string) => {
  moment.locale(lng?.startsWith('ar') ? 'ar' : 'en');
};

syncMomentLocale(i18n.language);
i18n.on('languageChanged', syncMomentLocale);

export default i18n;

